import type { FC, ReactNode } from 'react';
import { GLOBAL_NAVIGATION_HEIGHT, GLOBAL_NAVIGATION_Z_INDEX } from '@/shared/lib/constants';
import { cn } from '@/shared/lib/utils';

type Props = {
  className?: string;
  leftSection?: ReactNode;
  rightSection?: ReactNode;
};

export const GlobalNavigation: FC<Props> = ({ className, leftSection, rightSection }) => {
  return (
    <header
      style={{
        height: `${GLOBAL_NAVIGATION_HEIGHT}px`,
        zIndex: GLOBAL_NAVIGATION_Z_INDEX,
      }}
      className={cn(
        'sticky top-0 flex items-center',
        'border-border-base border-b bg-surface-base',
        'px-[8px] py-[8px]',
        leftSection && rightSection
          ? 'justify-between'
          : !leftSection
            ? 'justify-end'
            : 'justify-start',
        className,
      )}
    >
      {leftSection && leftSection}
      {rightSection && rightSection}
    </header>
  );
};
